class LoggingService {

    public log(e: any) {
        console.debug(`Error: Received response code '${e}' from the server`)
    }
}

export default LoggingService;